import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Synopsis`}</h3>
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/doctor.js */
    }
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm doctor
`}</code></pre>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/doctor.js */
    }
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS END */
    }
    <p>{`Note: This command is unaware of workspaces.`}</p>
    <h3>{`Description`}</h3>
    <p><inlineCode parentName="p">{`npm doctor`}</inlineCode>{` runs a set of checks to ensure that your npm installation has
what it needs to manage your JavaScript packages. npm is mostly a
standalone tool, but it does have some basic requirements that must be met:`}</p>
    <ul>
      <li parentName="ul">{`Node.js and git must be executable by npm.`}</li>
      <li parentName="ul">{`The primary npm registry, `}<inlineCode parentName="li">{`registry.npmjs.com`}</inlineCode>{`, or another service that
uses the registry API, is available.`}</li>
      <li parentName="ul">{`The directories that npm uses, `}<inlineCode parentName="li">{`node_modules`}</inlineCode>{` (both locally and
globally), exist and can be written by the current user.`}</li>
      <li parentName="ul">{`The npm cache exists, and the package tarballs within it aren't corrupt.`}</li>
    </ul>
    <p>{`Without all of these working properly, npm may not work properly.  Many
issues are often attributable to things that are outside npm's code base,
so `}<inlineCode parentName="p">{`npm doctor`}</inlineCode>{` confirms that the npm installation is in a good state.`}</p>
    <p>{`Also, in addition to this, there are also very many issue reports due to
using old versions of npm. Since npm is constantly improving, running
`}<inlineCode parentName="p">{`npm@latest`}</inlineCode>{` is better than an old version.`}</p>
    <p><inlineCode parentName="p">{`npm doctor`}</inlineCode>{` verifies the following items in your environment, and if there
are any recommended changes, it will display them.`}</p>
    <h4><inlineCode parentName="h4">{`npm ping`}</inlineCode></h4>
    <p>{`By default, npm installs from the primary npm registry,
`}<inlineCode parentName="p">{`registry.npmjs.org`}</inlineCode>{`.  `}<inlineCode parentName="p">{`npm doctor`}</inlineCode>{` hits a special ping endpoint within the
registry. This can also be checked with `}<inlineCode parentName="p">{`npm ping`}</inlineCode>{`. If this check fails,
you may be using a proxy that needs to be configured, or may need to talk
to your IT staff to get access over HTTPS to `}<inlineCode parentName="p">{`registry.npmjs.org`}</inlineCode>{`.`}</p>
    <p>{`This check is done against whichever registry you've configured (you can
see what that is by running `}<inlineCode parentName="p">{`npm config get registry`}</inlineCode>{`), and if you're using
a private registry that doesn't support the `}<inlineCode parentName="p">{`/whoami`}</inlineCode>{` endpoint supported by
the primary registry, this check may fail.`}</p>
    <h4><inlineCode parentName="h4">{`npm -v`}</inlineCode></h4>
    <p>{`While Node.js may come bundled with a particular version of npm, it's the
policy of the CLI team that we recommend all users run `}<inlineCode parentName="p">{`npm@latest`}</inlineCode>{` if they
can. As the CLI is maintained by a small team of contributors, there are
only resources for a single line of development, so npm's own long-term
support releases typically only receive critical security and regression
fixes. The team believes that the latest tested version of npm is almost
always likely to be the most functional and defect-free version of npm.`}</p>
    <h4><inlineCode parentName="h4">{`node -v`}</inlineCode></h4>
    <p>{`For most users, in most circumstances, the best version of Node will be the
latest long-term support (LTS) release. Those of you who want access to new
ECMAscript features or bleeding-edge changes to Node's standard library may
be running a newer version, and some may be required to run an older
version of Node because of enterprise change control policies. That's OK!
But in general, the npm team recommends that most users run Node.js LTS.`}</p>
    <h4><inlineCode parentName="h4">{`npm config get registry`}</inlineCode></h4>
    <p>{`You may be installing from private package registries for your project or
company. That's great! Others may be following tutorials or StackOverflow
questions in an effort to troubleshoot problems you may be having.
Sometimes, this may entail changing the registry you're pointing at.  This
part of `}<inlineCode parentName="p">{`npm doctor`}</inlineCode>{` just lets you, and maybe whoever's helping you with
support, know that you're not using the default registry.`}</p>
    <h4><inlineCode parentName="h4">{`which git`}</inlineCode></h4>
    <p>{`While it's documented in the README, it may not be obvious that npm needs
Git installed to do many of the things that it does. Also, in some cases
– especially on Windows – you may have Git set up in such a way that it's
not accessible via your `}<inlineCode parentName="p">{`PATH`}</inlineCode>{` so that npm can find it. This check ensures
that Git is available.`}</p>
    <h4>{`Permissions checks`}</h4>
    <ul>
      <li parentName="ul">{`Your cache must be readable and writable by the user running npm.`}</li>
      <li parentName="ul">{`Global package binaries must be writable by the user running npm.`}</li>
      <li parentName="ul">{`Your local `}<inlineCode parentName="li">{`node_modules`}</inlineCode>{` path, if you're running `}<inlineCode parentName="li">{`npm doctor`}</inlineCode>{` with a
project directory, must be readable and writable by the user running npm.`}</li>
    </ul>
    <h4>{`Validate the checksums of cached packages`}</h4>
    <p>{`When an npm package is published, the publishing process generates a
checksum that npm uses at install time to verify that the package didn't
get corrupted in transit. `}<inlineCode parentName="p">{`npm doctor`}</inlineCode>{` uses these checksums to validate the
package tarballs in your local cache (you can see where that cache is
located with `}<inlineCode parentName="p">{`npm config get cache`}</inlineCode>{`). In the event that there are corrupt
packages in your cache, you should probably run `}<inlineCode parentName="p">{`npm cache clean -f`}</inlineCode>{` and
reset the cache.`}</p>
    <h3>{`Configuration`}</h3>
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`registry`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: "`}<a parentName="li" {...{
          "href": "https://registry.npmjs.org/%22"
        }}>{`https://registry.npmjs.org/"`}</a></li>
      <li parentName="ul">{`Type: URL`}</li>
    </ul>
    <p>{`The base URL of the npm registry.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS END */
    }
    <h3>{`See Also`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-bugs"
        }}>{`npm bugs`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-help"
        }}>{`npm help`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-ping"
        }}>{`npm ping`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      